// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2p920","header":"MergedInvoice_header__2gPaA"};